<template>
  <PaymentType
    :payment-data="payment"
    :payment-due-date-visible="paymentDueDateVisible"
    :disabled="disabled"
    @update="updateFormValue"
  />
</template>

<script>
import PaymentType from '../Partials/PaymentType'
import updateFormValue from '../../../mixins/updateFormValue'

export default {
  mixins: [updateFormValue],
  props: {
    data: {
      type: Object,
      required: true
    },
    paymentDueDateVisible: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PaymentType,
  },
  data: () => ({
    emitAllowed: false,
    payment: {
      paymentType: null,
      paymentDueDays: null,
    }
  }),
  watch: {
    payment: {
      deep: true,
      handler (payment) {
        if (this.emitAllowed) this.$emit('update', payment)
      }
    }
  },
  mounted () {
    const { paymentType, paymentDueDays } = this.data.payment || this.data || {}
    this.payment = {
      paymentType,
      paymentDueDays
    }
    this.$nextTick(() => {
      this.emitAllowed = true
    })
  },
}
</script>
